const initialState = {
    advocateData: {}
  };
  
  const advocateDataReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'ADVOCATEDATA':
        if(!action.payload) {
          return initialState
        }
        else{
          return{
            ...state,
            advocateData : action.payload
          }
        }
      default:
        return state;
    }
  };
  
  export default advocateDataReducer;